module.exports = __webpack_public_path__ + "static/media/empresa2.984c7cf8.jpg";